import { render, staticRenderFns } from "./ListaStakeholder.vue?vue&type=template&id=1703c4e6&"
import script from "./ListaStakeholder.vue?vue&type=script&lang=js&"
export * from "./ListaStakeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports